export const routes = {
  home: "/",
  login: "/login",
  purchase: "/purchase",
  verifyAuth: "/auth/:token/business/:businessId",
  topupHistory: "/topup-history",
  chooseBusiness: "/choose-business",
  paymentManagement: "/payment-management",
  transactionStatus: "/transactionStatus",
};
